import { ComponentPropsWithoutRef } from 'react'
import { PageInfo } from '@/src/@types/models'
import { cn } from '@/src/components/core/lib/utils'
import { replaceGradient } from '@/src/lib/replaceGradient'
import { replaceLink } from '@/src/lib/replaceLink'

export const textSizes = {
  xl: 'md:prose-xl',
  lg: 'md:prose-lg',
  base: '',
  allBase: 'prose-base',
  sm: 'prose-sm md:prose-base',
  allSm: 'prose-sm',
}

export const titleSizes = {
  base: 'prose-h1:text-4xl prose-h2:mb-4 md:prose-h2:mb-6 prose-h3:mb-4 md:prose-h3:mb-6 prose-h4:mb-4 md:prose-h4:mb-6 md:prose-h1:text-20xl prose-h2:text-4xl md:prose-h2:text-20xl prose-h3:text-2xl md:prose-h3:text-10xl prose-h4:text-lg md:prose-h4:text-4xl',
  magazine:
    'prose-h1:text-4xl prose-h1:mb-6 md:prose-h1:mb-8 md:prose-h1:text-10xl prose-h2:text-2xl prose-h2:mb-6 md:prose-h2:mt-16 prose-h2:mt-12 md:prose-h2:text-7xl md:prose-h3:mt-12 md:prose-h3:mb-4 prose-h3:mt-8 prose-h3:mb-3 prose-h3:text-lg md:prose-h3:text-4xl prose-h4:text-lg prose-h4:font-bold prose-h4:mt-6 prose-h4:mb-3 md:prose-h4:mt-10 md:prose-h4:mb-3 md:prose-h4:text-xl md:prose-h4:font-black',
}

const linkColor =
  process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE === 'flch'
    ? 'prose-a:text-blue-700 prose-a:hover:text-blue-800'
    : 'prose-a:text-purple-600 prose-a:hover:text-purple-800'

export const textColors = {
  default: `prose-headings:text-gray-900 prose-p:text-gray-900 ${linkColor}`,
  white:
    'prose-headings:text-white prose-p:text-white prose-a:underline! prose-a:text-white',
}

export default function Content({
  content,
  className,
  textSize = 'lg',
  textColor = 'default',
  pageInfo,
  ...props
}: {
  content?: string
  textSize?: keyof typeof textSizes
  textColor?: keyof typeof textColors
  pageInfo?: PageInfo
} & Omit<ComponentPropsWithoutRef<'div'>, 'style'>) {
  return (
    <div
      {...props}
      className={cn([
        className,
        textSizes[textSize],
        textColors[textColor],
        titleSizes[pageInfo?.blueprint === 'magazine' ? 'magazine' : 'base'],
        'prose prose-headings:font-black prose-p:font-normal prose-a:font-bold prose-a:no-underline prose-strong:font-bold prose-strong:text-current',
        // custom table styling
        'prose-table:text-lg prose-tr:border-0 prose-tr:odd:bg-gradient-100 prose-tr:even:bg-white prose-th:px-6 prose-th:py-5 prose-th:first:rounded-l-[5px] prose-th:last:rounded-r-[5px] prose-td:px-6! prose-td:py-5! prose-td:first:rounded-l-[5px] prose-td:last:rounded-r-[5px]',
      ])}
      dangerouslySetInnerHTML={{
        __html: content ? replaceLink(replaceGradient(content)) : '',
      }}
    />
  )
}
